import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListSPIAuthorize = async (param) => {
  let url = `${API_URL.Loader}/api/SPIAuthorize/GetListSPIAuthorize`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const DeleteJobScheduleQuota = async (param) => {
  let url = `${API_URL.Loader}/api/Job/DeleteJobScheduleQuota`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetViewDetailSPIAuthorizeByUser = async (param) => {
  let url = `${API_URL.Loader}/api/SPIAuthorize/GetViewDetailSPIAuthorizeByUser`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DeleteSPIUser = async (param) => {
  let url = `${API_URL.Loader}/api/SPIAuthorize/DeleteSPIUser`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const SaveSPIAuthorize = async (param) => {
  let url = `${API_URL.Loader}/api/SPIAuthorize/SaveSPIAuthorize`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetJobScheduleQuotaInfo = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetJobScheduleQuotaInfo`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const InitScreen = async (param) => {
  let url = `${API_URL.Loader}/api/SPIAuthorize/InitScreen`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
